var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.catalogCompensation)?_c('simple-text',{attrs:{"content":_vm.catalogCompensation.catalogStrategy}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }